import { ApiStatus } from '@/utils/HttpApi'

const SUCCESS: ApiStatus = 'success'
const FAIL: ApiStatus = 'fail'
const ERROR: ApiStatus = 'error'
const CANCELLED: ApiStatus = 'cancelled'

const HttpStatus = {
    SUCCESS,
    FAIL,
    ERROR,
    CANCELLED,
}

export { HttpStatus }
